import React from 'react';
import axios from './../../sagas/axios';
import ModalConfirm from '../modal/modal_confirm';

const MarkEventUserAttendance = ({ eventsPlansUser, circleId }) => {
  const attendanceConfirmRef = React.useRef(null);

  const handleAttendanceEventsPlansUser = React.useCallback(
    () => {
      const body = {
        events_plans_user_id: eventsPlansUser.id,
        circle_id: circleId,
        is_attend: !eventsPlansUser.is_attend
      };
      const url = '/api/event/update_event_user_attendance';
      
      axios
        .request({ method: 'post', url, data: body })
        .then(() => {
          location.reload()
        })
        .catch(() => {
          alert(
            '登録に失敗しました。お時間をおいてからもう一度実行してください。'
          );
        });
    },
    [eventsPlansUser, circleId]
  );

  const fullname_disp = user => {
    if (user.is_fullname_hidden && user.is_verified_identity) {
      return `@${user.tunagate_id}(本人確認済)`;
    } else if (!user.is_fullname_hidden && user.is_verified_identity) {
      return `${user.familyname} ${user.firstname}(本人確認済)`;
    } else {
      return `${user.familyname} ${user.firstname}`;
    }
  };

  return (
    <React.Fragment>
      {eventsPlansUser.is_attend ? (
        <span
          onClick={() => attendanceConfirmRef.current.openModal()}
          className="ml-2 badge badge-success"
          style={{ cursor: 'pointer' }}
        >
          出席確認
        </span>
      ) : (
        <span
        onClick={() => attendanceConfirmRef.current.openModal()}
        className="ml-2 badge badge-danger"
        style={{ cursor: 'pointer' }}
        >
          出席未確認
        </span>
      )}
      <ModalConfirm
        ref={attendanceConfirmRef}
        approveFunc={handleAttendanceEventsPlansUser}
        title={
          eventsPlansUser.user.is_fullname_hidden
            ? ' '
            : `${fullname_disp(eventsPlansUser.user)}さんの出欠変更`
        }
        content={`${
          eventsPlansUser.is_attend ? '欠席' : '出席'
        }に変更しますか？`}
      />
    </React.Fragment>
  )
};

export default MarkEventUserAttendance;
